// src/pages/volunteering/fieldList.js
import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

const FieldList = ({ fields, setFields, setEditFieldIndex, setEditorOpen }) => {
  const handleDelete = (index) => {
    setFields(fields.filter((_, i) => i !== index));
  };

  const handleEdit = (index) => {
    setEditFieldIndex(index);
    setEditorOpen(true);
  };

  if (fields.length === 0) {
    return <p className="vfl-empty-fields">No fields added yet.</p>;
  }

  return (
    <div className="vfl-field-list">
      {fields.map((field, index) => (
        // FIX #6: Use field.id as key instead of array index.
        // Using index causes React to misidentify which item changed
        // when fields are deleted or reordered, leading to stale UI state.
        <div key={field.id} className="vfl-field-list-item">
          <div className="vfl-field-list-info">
            <span className="vfl-field-list-label">{field.label}</span>
            <span className="vfl-field-list-type">{field.type}</span>
            {field.required && <span className="vfl-field-list-required">Required</span>}
          </div>
          <div className="vfl-field-list-actions">
            <button className="vfl-table-edit-btn" onClick={() => handleEdit(index)}>
              <FaEdit />
            </button>
            <button className="vfl-table-delete-btn" onClick={() => handleDelete(index)}>
              <FaTrash />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FieldList;
